import { all } from 'redux-saga/effects';
import { legalSaga } from './legalSaga';
import interviewSaga from './InterviewSaga';


// Root saga
export default function* rootSaga() {
  yield all([
    interviewSaga(),
    legalSaga(),
  ]);
}